<template>
    <header class="index-header">
        <div class="bg-wrap">
            <div class="bg"></div>
        </div>

        <div class="slogan-wrap">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="top-banner-wrap">
                            <img :src="index_banner" alt="">
                            <div class="sd-area-pc" @click="scrolldown_pc">
                                <img :src="bean" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        
        

        


        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="video-box-wrap">
                        <div class="video-box">
                            <!-- <iframe id="video" src="https://www.youtube.com/embed/i7-CkbK8VBM?enablejsapi=1&html5=1&rel=0&amp;autoplay=0&mute=1&playsinline=1" frameborder="0" allowfullscreen></iframe> -->
                            <iframe id="main-video" :src="`${link}?mute=1&enablejsapi=1&version=3&playerapiid=ytplayer&playsinline=1`" frameborder="0" allowfullscreen></iframe>   
                        </div>
                        <p class="video-text">{{video_text}}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="sd-area-m" @click="scrolldown_m">
                        <img :src="bean" alt="">
                    </div>
                    
                </div>
            </div>
        </div>
        <!-- <button id="play" @click="YTplay">tesgrdgdrgdgvt</button> -->

        <!-- <div class="mask" :class="(header_loaded)?'mask_fade_out':''">
            <img :src="bean" alt="">
        </div> -->

        


    </header>
    
</template>
<script>



import bgimg from '../assets/index-bg123.jpg';
import bgimg_m from '../assets/index-bg-m.png';

import bean from '../assets/bean.png';
import index_banner from '../assets/header-img.png';


export default {
    data(){
        return {
            bean,
            index_banner,
            bgimg,
            player: "",
            video_text: "Bodum 北歐時尚 - 最後倒數",
            link: ""
        }
    },
    computed: {
        // mask_style(){
        //     //mask-fade-out

        // }
    },
    methods: {
        onYouTubePlayerAPIReady(){
            this.player = new YT.Player('main-video', {
                events: {
                    //'onReady': this.onPlayerReady
                    'onReady': this.YTplay
                }
            });
        },
        YTplay(){
            this.player.playVideo();
            setTimeout(()=>{
                this.player.playVideo();
            },100);
            setTimeout(()=>{
                this.player.playVideo();
            },200);
            
            //$('#main-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        },
        scrolldown_pc(){
            //console.log($(".sd-area-pc").offset().top)
            $("HTML, BODY").animate({ scrollTop: $(".sd-area-pc").offset().top }, 500);
        },
        scrolldown_m(){
            let top = $(".flex-section").offset().top - $("nav").outerHeight();
            $("HTML, BODY").animate({ scrollTop: top }, 500);

        }

    },
    updated(){
        //this.onYouTubePlayerAPIReady();
        //this.YTplay();
    },
    mounted(){
        
        setTimeout(()=>{
            this.onYouTubePlayerAPIReady();
        },2000);


        $('.sd-area-pc').on('click', function (e) {
			gtag('event', '點擊', {
				'event_category': '首頁-下滑按鈕',
				'event_action': '點擊',
				'event_label': '點擊次數'
			});
        });
        
        console.log("head!!")
        // console.log(cf_link);

    },
    created(){
        // (cf_link==undefined)?"test":this.link = cf_link;
        this.link = cf_link;
        //this.link="test"
        
        

    }
}




</script>

<style lang="sass">
.mask
    position: fixed
    width: 100vw
    height: 100vh
    z-index: 10000
    background: #000
    left: 0
    top: 0
    display: flex
    align-items: center
    justify-content: center
    transition: .3s
    opacity: 1
    img
        width: 50px
        height: 50px
        animation: 1.5s infinite scale

.mask_fade_out
    opacity: 0
    pointer-events: nones

@keyframes scale
    0%
        opacity: 0
        transform: scale(1s) translateY(0)

    100%
        opacity: 1
        transform: scale(1.2) translateY(20px)

header.index-header
    position: relative
    overflow: hidden
    display: block
    //padding-top: 180px
    padding-bottom: 150px
    z-index: 1000
    @media (max-width: 1024px)
        padding-top: 180px
    @media (max-width: 768px)
        padding-top: 150px
        padding-bottom: 150px
    @media only screen and (max-height: 812px) and (max-width: 375px)
        padding: 0
        height: 100vh
        display: flex
        flex-wrap: wrap
        .slogan-wrap, .container
            width: 100%
        .slogan-wrap
            margin-bottom: 0 !important
            margin-top: 80px

    @media (max-height: 600px)
        padding-top: 0px
        padding-bottom: 100px
        .slogan-wrap
            margin-bottom: 50px !important

    
    .slogan-wrap
        height: 100vh
        display: flex
        justify-content: center
        align-items: center
        @media (max-width: 1024px)
            height: auto
            margin-bottom: 60px
    .bg-wrap
        clip: rect(0, auto, auto, 0)
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        pointer-events: none
        .bg
            background-image: url('../assets/index-bg123.jpg')
            position: fixed
            display: block
            top: 0
            left: 0
            width: 100%
            height: 100%
            background-size: cover
            background-position: center center
            transform: translateZ(0)
            will-change: transform
            z-index: -1000
            @media (max-width: 768px)
                background-image: url('../assets/index-bg-m.png')


    .top-banner-wrap
        //padding: 50px
        position: relative
        text-align: center
        img
            width: 95%
    .sd-area-pc, .sd-area-m
        //display: none
        position: absolute
        text-align: center
        //padding: 50px 0
        left: 50%
        bottom: 0
        transform: translate(-50%, 200%)
        @media (max-width: 1024px)
            display: none
        
        img
            width: 45px
            cursor: pointer
            animation: 2s infinite scroll
    .sd-area-m
        display: none
        img
            width: 40px
        @media (max-width: 1024px)
            display: block
        @media (max-height: 700px)
            bottom: 50px
        @media (max-height: 600px)
            bottom: 40px
    .video-box-wrap
        border: 50px solid black
        border-bottom: none
        text-align: center
        width: 90%
        //margin: 0 15px
        @media (max-width: 991px)
            border: 20px solid black
            border-bottom: none
        @media (max-width: 576px)
            border: 10px solid black
            border-bottom: none

@keyframes scroll
    0%
        opacity: 1
        transform: translateY(0)

    100%
        opacity: 1
        transform: translateY(20px)

    

        
    

    


</style>



// WEBPACK FOOTER //
// src/Index/header.vue